import Button from '@/Components/Button';
import Spinner from '@/Components/Spinner';
import React, { useState } from 'react'

const ExportButton = ({ id, children = 'Descargar reporte' }) => {

    const [loading, setLoading] = useState(false)

    const handleDownloadFile = async () => {
        setLoading(true);
        const response = await axios.get(route('export.sales.download', { id }));
        if (response.data.status === 'success') {
            const url = response.data.data;
            window.open(url, '_blank');
        }
        setLoading(false);
    }

    return (
        <Button
            onClick={handleDownloadFile}
            processing={loading}
            style={{ maxWidth: 220 }}
            className="w-full flex justify-center items-center ml-auto whitespace-nowrap"
        >
            {loading ? <Spinner width="1rem" height="1rem" weight={2} color="transparent" backgroundColor="#ffffff" /> : children}
        </Button>
    )
}

export default ExportButton